import { useState } from "react";
import PhoneSheet from "../components/PhoneSheet";

// ── Static data ───────────────────────────────────────────────────────────────

const FEATURES = [
  { icon: "⚡", label: "Instant",   sub: "In 2 hours"   },
  { icon: "📄", label: "Paperless", sub: "Digital KYC"  },
  { icon: "🔁", label: "Flexible",  sub: "3–24 months"  },
];

const QUICK_ACTIONS = [
  { icon: "↔",  label: "Transfer" },
  { icon: "🧾", label: "Repay"    },
  { icon: "📈", label: "Track"    },
  { icon: "🎧", label: "Support"  },
];

const ACTIVITY = [
  { label: "Loan disbursed",      time: "Today, 10:32 AM", amount: "+₹50,000", color: "#86efac", bg: "rgba(34,197,94,0.15)",   border: "rgba(34,197,94,0.25)",   dir: "↙" },
  { label: "EMI payment",         time: "Jun 10, 9:00 AM", amount: "-₹4,625",  color: "#fde68a", bg: "rgba(251,191,36,0.12)",  border: "rgba(251,191,36,0.25)",  dir: "↗" },
  { label: "Credit score updated",time: "Jun 8, 12:00 PM", amount: "748",      color: "#7dd3fc", bg: "rgba(14,165,233,0.15)",  border: "rgba(14,165,233,0.25)",  dir: "★" },
];

// ── Style helpers ─────────────────────────────────────────────────────────────

const glass = {
  background: "rgba(255,255,255,0.07)",
  border: "1px solid rgba(255,255,255,0.13)",
  borderRadius: 20,
  backdropFilter: "blur(10px)",
};

const pill = {
  background: "rgba(14,165,233,0.22)",
  border: "1px solid rgba(14,165,233,0.4)",
  borderRadius: 20,
  padding: "4px 12px",
  fontSize: 11,
  color: "#7dd3fc",
  display: "inline-block",
  marginBottom: 16,
};

// ── Component ─────────────────────────────────────────────────────────────────

export default function HomeScreen() {
  const [showSheet, setShowSheet] = useState(false);
  const [ctaText, setCtaText]     = useState("Get cash now  →");

  const handleCta = () => {
    setCtaText("Processing...");
    setShowSheet(true);
    setTimeout(() => setCtaText("Get cash now  →"), 2000);
  };

  return (
    <div style={{ background: "#0a1628", minHeight: "100dvh", position: "relative", overflow: "hidden", paddingBottom: "88px" }}>

      {/* Ambient orbs */}
      <div style={{ position: "absolute", top: -80, left: -60, width: 320, height: 320, borderRadius: "50%", background: "#0ea5e9", opacity: 0.18, filter: "blur(60px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", top: 60, right: -80, width: 260, height: 260, borderRadius: "50%", background: "#38bdf8", opacity: 0.13, filter: "blur(60px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", top: 300, left: 40, width: 200, height: 200, borderRadius: "50%", background: "#7dd3fc", opacity: 0.10, filter: "blur(60px)", pointerEvents: "none" }} />

      <div style={{ position: "relative", zIndex: 1, padding: "0 20px", maxWidth: 480, margin: "0 auto" }}>

        {/* ── Header ── */}
        <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "24px 0 20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 42, height: 42, borderRadius: "50%", background: "#0ea5e9", display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid rgba(255,255,255,0.25)", fontSize: 22 }}>
              ₹
            </div>
            <div>
              <p style={{ fontSize: 11, color: "#7dd3fc", marginBottom: 1 }}>Welcome</p>
              <p style={{ fontSize: 15, fontWeight: 500, color: "#f0f9ff" }}>Hi there 👋</p>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            {[{ badge: true, icon: "🔔" }, { badge: false, icon: "☰" }].map((btn, i) => (
              <div key={i} style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.13)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", cursor: "pointer" }}>
                <span style={{ fontSize: 18, color: "#bae6fd" }}>{btn.icon}</span>
                {btn.badge && <span style={{ position: "absolute", top: 8, right: 9, width: 7, height: 7, background: "#f87171", borderRadius: "50%", border: "1.5px solid #0a1628" }} />}
              </div>
            ))}
          </div>
        </header>

        {/* ── Hero card ── */}
        <div style={{ ...glass, padding: 24, marginBottom: 16, position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: 0, right: 0, width: 140, height: 140, borderRadius: "50%", background: "#0ea5e9", opacity: 0.08, transform: "translate(40px,-40px)", pointerEvents: "none" }} />
          <span style={pill}>✓ Pre-approved</span>
          <p style={{ fontSize: 12, color: "#7dd3fc", marginBottom: 6 }}>Instant loan up to</p>
          <p style={{ fontSize: 42, fontWeight: 500, color: "#f0f9ff", lineHeight: 1, marginBottom: 4 }}>₹1,00,000</p>
          <p style={{ fontSize: 11, color: "#38bdf8", marginBottom: 20 }}>@ 1.5% monthly interest</p>

          {/* Bar */}
          <div style={{ background: "rgba(255,255,255,0.08)", borderRadius: 8, height: 6, overflow: "hidden", marginBottom: 8 }}>
            <div style={{ width: "72%", height: "100%", background: "#0ea5e9", borderRadius: 8 }} />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 18 }}>
            <span style={{ fontSize: 11, color: "#7dd3fc" }}>₹72k eligible</span>
            <span style={{ fontSize: 11, color: "#7dd3fc" }}>₹1L limit</span>
          </div>

          {/* Features */}
          <div style={{ display: "flex", gap: 16, paddingTop: 18, borderTop: "1px solid rgba(255,255,255,0.08)", flexWrap: "wrap" }}>
            {FEATURES.map((f) => (
              <div key={f.label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 40, height: 40, borderRadius: 12, background: "rgba(14,165,233,0.2)", border: "1px solid rgba(14,165,233,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>{f.icon}</div>
                <div>
                  <p style={{ fontSize: 12, fontWeight: 500, color: "#e0f2fe" }}>{f.label}</p>
                  <p style={{ fontSize: 11, color: "#7dd3fc" }}>{f.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── CTA ── */}
        <button onClick={handleCta} style={{ width: "100%", padding: "15px", border: "none", borderRadius: 14, background: "#0ea5e9", color: "#fff", fontSize: 15, fontWeight: 500, cursor: "pointer", letterSpacing: "0.02em", marginBottom: 16 }}>
          {ctaText}
        </button>

        {/* ── Credit score ── */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
          <div style={{ ...glass, padding: 18 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
              <p style={{ fontSize: 12, color: "#7dd3fc", fontWeight: 500 }}>Credit score</p>
              <span style={{ fontSize: 10, background: "rgba(34,197,94,0.15)", color: "#86efac", padding: "2px 8px", borderRadius: 20, border: "1px solid rgba(34,197,94,0.25)" }}>Good</span>
            </div>
            <div style={{ position: "relative", width: 72, height: 72, margin: "0 auto 10px" }}>
              <svg viewBox="0 0 72 72" style={{ width: 72, height: 72, transform: "rotate(-90deg)" }}>
                <circle cx="36" cy="36" r="28" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="7" />
                <circle cx="36" cy="36" r="28" fill="none" stroke="#0ea5e9" strokeWidth="7" strokeDasharray="176" strokeDashoffset="44" strokeLinecap="round" />
              </svg>
              <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <span style={{ fontSize: 16, fontWeight: 500, color: "#f0f9ff" }}>748</span>
                <span style={{ fontSize: 9, color: "#7dd3fc" }}>CIBIL</span>
              </div>
            </div>
            <p style={{ fontSize: 11, color: "#7dd3fc", textAlign: "center" }}>Premium rates available</p>
          </div>
          {/* Placeholder second card */}
          <div style={{ ...glass, padding: 18, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 32 }}>📊</span>
            <p style={{ fontSize: 12, color: "#7dd3fc", textAlign: "center" }}>EMI Planner</p>
            <p style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", textAlign: "center" }}>Coming soon</p>
          </div>
        </div>

        {/* ── Quick actions ── */}
        <div style={{ ...glass, padding: 20, marginBottom: 16 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <p style={{ fontSize: 14, fontWeight: 500, color: "#e0f2fe" }}>Quick actions</p>
            <span style={{ fontSize: 18, color: "#7dd3fc" }}>···</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {QUICK_ACTIONS.map((a) => (
              <div key={a.label} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <div style={{ width: 52, height: 52, borderRadius: 16, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>
                  <span>{a.icon}</span>
                </div>
                <span style={{ fontSize: 11, color: "#7dd3fc" }}>{a.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Recent activity ── */}
        <div style={{ ...glass, padding: 20 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <p style={{ fontSize: 14, fontWeight: 500, color: "#e0f2fe" }}>Recent activity</p>
            <span style={{ fontSize: 11, color: "#38bdf8", cursor: "pointer" }}>View all</span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {ACTIVITY.map((item, i) => (
              <div key={item.label}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ width: 38, height: 38, borderRadius: 12, background: item.bg, border: `1px solid ${item.border}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 18 }}>
                    {item.dir}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontSize: 13, fontWeight: 500, color: "#e0f2fe" }}>{item.label}</p>
                    <p style={{ fontSize: 11, color: "#7dd3fc" }}>{item.time}</p>
                  </div>
                  <p style={{ fontSize: 13, fontWeight: 500, color: item.color }}>{item.amount}</p>
                </div>
                {i < ACTIVITY.length - 1 && <div style={{ height: 1, background: "rgba(255,255,255,0.06)", marginTop: 14 }} />}
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Phone sheet */}
      <PhoneSheet show={showSheet} onClose={() => setShowSheet(false)} />

      <style>{`
        @keyframes slideUp { from { transform: translateX(-50%) translateY(100%); } to { transform: translateX(-50%) translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
